var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-viewer-container"},[_c('div',{ref:"modelContainer",staticClass:"model-container"}),(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v(" 加载中："+_vm._s(_vm.loadProgress)+"% ")]):_vm._e(),(_vm.errorMsg)?_c('div',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }